import React from "/vendor/react";

interface Props {
  variant?: "idle";
}

const Lizzy = ({
  variant = "idle",
  ...props
}: Props & React.SVGProps<SVGSVGElement>) => {
  if (variant === "idle") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 349.2 571"
        {...props}
      >
        <style>
          {`.st12{fill:#374453}.st13{fill:#88c867}.st14{fill:#6ea865}.st15{fill:#fefefe}.st16{fill:#b3d972}.st17{fill:#e8e8e8}`}
        </style>
        <g id="Layer_2">
          <path
            d="M122 567c-5-1-6-6-7-10-1-8-3-15-6-23 0-2-1-3-3-3-13-4-25-10-36-18a71 71 0 01-28-61c0-12 3-23 7-33l9-24c1-8 0-17-4-24l-15-21c-2-3-5-5-6-9-3-5-1-10 5-11s11 0 16 2c17 5 29 15 40 27l3 3 3-33c2-19 2-38 2-57 0-2-1-3-3-3-23-7-46-16-66-30-8-5-15-11-21-19-7-9-9-19-8-30 2-14 8-26 15-38v-4A85 85 0 011 85c6-26 17-49 40-65C53 12 66 7 80 5c21-2 40 5 55 20a88 88 0 0124 36h3a355 355 0 0143-2v-2c2-29 19-49 47-55 21-5 38 1 54 14 21 20 33 44 32 74 0 12-3 24-13 33-1 1 0 2 1 3 7 10 13 20 17 32 5 16 4 31-7 45-10 14-24 25-39 33-22 12-44 21-68 29a1360 1360 0 0124 92c6 24 11 47 14 71 2 15 3 31 2 46-2 25-15 43-38 52l-8 3c-2 1-3 1-3 3l-2 30-2 2c-5 2-9 3-14 1-3-1-5-4-5-7l-3-19c0-3 0-4-2-3-18 3-36 4-54 1-3 0-3 1-3 3v15c-1 5 0 10-5 12l-2 1-6-1z"
            className="st12"
          />
          <path
            d="M10 197c0-9 2-17 5-25l7-14c1-1 2 1 3 1 12 13 26 19 43 19 15-1 29-3 42-9 7-3 12-8 18-12a89 89 0 0027-39c4-9 7-18 8-28l-2-20c-1-2 0-3 2-3l32-2 11 1c2 12 6 22 12 32a84 84 0 0088 42c5-1 9-3 13-6 1-1 2-2 4-1 10 14 18 30 16 48 0 7-3 12-7 18l-10 5c-31 18-66 28-101 35-14 3-28 4-43 3l-36-4-45-6c-20-3-39-7-58-15-11-4-19-11-27-18l-2-2z"
            className="st13"
          />
          <path
            d="M10 197c9 8 19 16 31 20 9 4 18 6 28 9l48 9 31 3 42 3a452 452 0 00139-42h3c-6 8-14 15-23 22-14 10-31 18-48 25l-39 17-17 8c-1 1 0 1 1 1l12-4c1 0 2-1 3 1l-3 2c-11 6-23 10-36 13-5 1-10-1-15-1l-29-4c-4-1-4 0-4 3l-6 40a210 210 0 005 79l5 17c1 5 3 9 7 12l1 2c-1 1-1 4-3 4-2 1-3-1-4-3l-3-8-12-43-3-19-1-5-1 3c3 20 6 40 11 59l2 8c-2 3-3 7-3 10l-4 19-2 6-6 37v27l-22-7c-11-5-21-11-29-20-9-9-14-21-16-33-3-15-1-30 5-44 5-11 9-22 11-34l1 3v14l-8 29c-2 6-2 12 0 17 3 6 5 13 12 16 3 2 6 3 9 0h2l-1 3 1 2 2-2 4-16 10-60 5-38 4-44v-40c0-2 1-2 2-1l13 2-8-4-31-12c-20-7-38-17-54-30-5-3-9-7-13-12-4-6-7-12-6-19z"
            className="st14"
          />
          <path
            d="M22 49c7-11 16-20 28-27 12-6 25-11 38-10 16 0 30 6 41 16 16 15 25 33 27 55 0 9-1 18-5 27-1 2-2 3-4 3l-13 7-14 5-19 4H81c-9-1-19-2-28-8-14-8-24-20-30-36-4-8-5-17-4-27l3-9z"
            className="st15"
          />
          <path
            d="M145 430c-3-1-4-3-6-6-4-7-5-15-7-22l-4-22-2-16v-27c-1-7 1-15 2-22l4-29 1-6c0-2 0-2 2-2l20 3 15 1c15 2 28-3 41-9l10-4a1047 1047 0 0140 174l1 8c-2 5-5 7-9 10l-12 7-3 1-1-1-4-13a221 221 0 00-6-19c4-4 5-10 6-15 3-25 4-66 0-72l-1 3v14c1 14-1 27-2 40-1 5-1 10-3 14l-3 6c-2 0-3-1-4-3l-4-14v-8l-1-23c-1-9-2-18-6-26l-2-3c-1 2 0 4-2 6v-1l-1-5-2-29c-1-9-7-14-14-17-11-5-23-3-33 2-4 1-6 4-8 8-3 9-3 18-2 27v12 12l2 32v31l-2 3z"
            className="st13"
          />
          <path
            d="M212 63c-1-9 1-17 4-24s8-14 13-19c15-14 43-17 62-6 21 13 33 32 39 55v5c-2 6-6 11-11 14a69 69 0 01-66 3l-22-10c-8-5-14-11-19-18z"
            className="st15"
          />
          <path
            d="M237 468h1l1 4c2 13 2 26 0 39l-1 4c-8 5-18 8-27 10a221 221 0 01-92 2h-2l-1-18c-1-13 2-25 4-37l3-9c6 11 18 14 29 19 6 3 11 4 18 3h20c12-1 23-6 34-10l10-5 3-2z"
            className="st16"
          />
          <path
            d="M22 49l-2 11c-1 5 0 9 1 14 2 14 8 25 18 35 8 8 17 15 29 17 9 2 18 4 27 3l12-2c7-1 15-3 22-6l15-8c3 0 5-1 7-3-5 14-14 26-26 36-26 21-54 21-83 9-19-7-27-22-32-40-6-18-2-37 6-54l6-12z"
            className="st17"
          />
          <path
            d="M82 468c-5 4-7 4-12 1-8-5-10-13-13-20-2-7 1-13 2-19 3-8 6-17 7-26 1-5 2-10 0-15 0-13-6-24-14-34l-12-15-1-3h3c9 0 17 4 25 8 11 7 19 15 26 25 3 3 2 6 2 9l-9 63-4 26z"
            className="st13"
          />
          <path
            d="M212 63l7 7c7 7 15 12 24 16 10 4 19 9 30 10l16 1c11-1 21-6 31-11 4-3 7-7 10-12 3 13 2 25-4 36-6 12-16 17-29 17-28 1-51-11-69-32-7-9-12-18-15-29l-1-3z"
            className="st17"
          />
          <path
            d="M323 133c-9 7-19 9-31 9-17 1-32-4-47-13a105 105 0 01-39-55v-8c2 8 5 15 9 21 9 12 19 23 31 30 9 5 17 11 26 14a62 62 0 0043-1c5-2 5-2 8 3zM155 118c1 3 0 5-1 7-5 9-10 18-18 25a87 87 0 01-45 26c-14 3-28 4-42 0-10-3-18-9-25-16l-2-2v-1c1-3 2-3 5-2 13 9 28 14 44 15 20 2 38-4 55-16 12-9 22-22 29-36zM238 515l2-28-2-19c8-4 17-8 22-15l2-2c1 12 1 23-2 35s-11 22-22 29z"
            className="st14"
          />
          <path
            d="M215 543l-1 16-2 2h-9c-2 0-1-2-2-3l-1-13c5-1 10-3 15-2zM131 546l-1 13c0 2 0 4-3 4s-5 0-6-3l-2-8-2-9 1-1 11 2 2 2z"
            className="st13"
          />
          <path
            d="M215 543l-15 2-2-9 2-2c5 0 9-1 14-3 2 0 3 0 2 3l-1 9z"
            className="st14"
          />
          <path
            fill="#6da865"
            d="M131 546l-13-3h-1l-4-8c0-1 0-2 2-2 4 2 9 3 14 3 1 0 2 1 2 3v7z"
          />
          <path
            d="M133 209c-2 4-3 8-7 11-2 1-4 0-5-1-3-2-4-5-6-8l-4-11c0-2-1-3-4-3-4 0-7 1-11-1-1 0-3 0-3-2 2-2 4-2 6-2 12-1 24 1 36 2a371 371 0 0061 3c21-1 41-4 61-13 13-6 27-12 40-20l4-2 1-1c-3 5-8 9-12 12a205 205 0 01-65 28l-19 2h-23l-43-2c-4-1-4-1-5 3l-2 5z"
            className="st12"
          />
          <path
            d="M133 209l2-7c0-2 1-3 3-3l38 3c11 1 22 0 33-1 10 0 21-2 31-5 13-4 27-9 39-16l11-7c-2 5-7 9-11 12-15 11-32 17-50 20-17 3-34 6-52 5l-40-2-4 1zM93 194c1 2 4 2 6 2h8c3 0 5 1 5 4 2 6 4 11 7 15 1 3 3 5 7 5-3 2-5 1-7 0-3-2-5-4-5-7-1-5-4-7-9-7s-9-2-13-5c-3-4-2-5 1-7z"
            className="st14"
          />
          <path fill="#384553" d="M185 118l2-5 4 1 2 3c0 2 3 3 1 5l-8-3-1-1z" />
          <path
            fill="#394753"
            d="M211 114c0-1-1-3 1-3h3c2 1 1 2 1 3v1c-1 2 0 5-3 5-1 1-2-4-2-6z"
          />
          <path
            fill="#c6ea88"
            d="M237 468c-6 5-14 8-21 11-9 4-17 6-27 7h-15c-15 2-28-5-40-11l-10-8c0-2-2-3-1-4l5-22v-3l1-2 2 1 3 5c3 5 7 5 11 0 5-5 6-12 6-18 1-13-1-26-2-39l-4-30v-4c-2-13-4-27 2-40 2-4 5-6 9-8l13-4c8-1 16 1 23 5s10 10 11 17l2 33c1 3-1 6-1 8l2 18v7c-2 13 0 26 1 40 1 4 2 9 6 12 4 4 9 3 13 0l2-2 5 14 4 17z"
          />
          <path
            d="M145 351l3 24 3 27c1 9 2 19 1 28-1 5-2 10-7 13l-3 1c-5-1-11-10-11-15-5-16-7-33-10-49l-3-20 1-3 2-1v1c2 19 7 36 12 54l5 19 1 1c1 2 2 5 4 5 2-1 2-4 2-6l2-10-1-36-2-30c0-1-1-2 1-3z"
            className="st12"
          />
          <path
            fill="#b3d872"
            d="M131 429c2 3 3 7 6 10 2 3 5 5 8 4-2 4-7 4-11 1l-5-7-1 1 2-9h1z"
          />
          <path
            d="M80 75c2 8 1 17-2 26-2 5-4 10-10 11s-10-3-13-8c-9-14-9-28-4-43 2-4 4-8 9-9 5-2 12 2 15 9-5-3-9-3-13 1-4 5-5 10-3 15s11 10 16 4l4-6h1z"
            className="st12"
          />
          <path fill="#767f8a" d="M80 75h-1l1-2v2z" />
          <path
            d="M224 425a339 339 0 008-76v-2l2 1a386 386 0 01-1 73c0 6-3 10-7 14l-8 4c-4 1-7 0-9-4l-2-10v-25l-2-36 1-9v-5-2c2-1 2 1 2 2l1 1a452 452 0 017 73c0 2-1 5 2 5 1 1 3-1 4-2l2-2z"
            className="st12"
          />
          <path
            d="M206 354l1 16 1 55 1 8c2 5 5 7 10 5l7-4c2 0 2 1 2 2v1c-2 3-4 6-9 6s-8-3-10-7l-3-12c0-10-3-19-2-29v-32l1-9h1z"
            className="st16"
          />
          <path
            d="M224 425c-1 3-4 5-6 6-1 1-2 0-2-1l-1-5v-27l-2-28-4-19c3 2 3 5 3 8 3 9 4 18 4 27 0 11 0 22 4 33 0 3 0 6 4 6z"
            className="st14"
          />
          <path
            fill="#6ea764"
            d="M228 436c0-1 0-2-2-2 4-4 6-8 7-12l-3 12-2 2z"
          />
          <path
            d="M299 39l-2-1c-2-2-4-2-6-1-7 4-9 17-3 22 4 4 8 3 11-1l4-6 1 3c0 8 0 17-3 25l-3 6c-3 5-9 5-13 0-6-7-8-15-9-24 0-6 0-13 2-20l4-9c2-4 7-5 11-3l6 9z"
            className="st12"
          />
          <path
            fill="#fdfdfd"
            d="M131 202l-4 10-2 4c-2 0-3-2-3-3l-5-9v-2c3-2 12-2 14 0z"
          />
          <path
            fill="#e6e6e6"
            d="M131 204c-4 0-8-3-11-2-1 0-3 1-3 3l-2-8 16 2c2 0 1 2 0 5z"
          />
        </g>
      </svg>
    );
  }
  return null;
};

export default Lizzy;
